import { lazy } from "react";
import { ElementDetails } from "@/lib/types";
import { BoardsProps } from "./types";

export const details = {
  name: "PinterestBoards",
  description: "Display your Pinterest boards in a carousel",
  tags: ["Design", "Organization"],
  category: "Pinterest",
  grid: {
    "4x2": [4, 2],
    "4x3": [4, 3],
    "4x4": [4, 4],
  },
  app: lazy(() => import("./App").then(m => ({ default: m.AppView }))),
  defaultProps: {},
  integrationsUsed: ["pinterest"],
} as ElementDetails<BoardsProps>;
